//import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from 'react';
import { Tab } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getDashboardCount } from '@src/store/slices/common';
import { useDispatch, useSelector } from 'react-redux'
import secureStorage from "@src/config/encrypt";
import { toast } from 'react-toastify';
import FullPageLoader from '@src/common/FullPageLoader';
import { FEATURE_LISTING, INS_INSURANCE_ID_STAGE, STATUS_SUCCESS } from '@src/config/constant';
import { useLanguage } from "@src/context/LanguageContext";
import {APP_AGENCY} from '@src/config/constant';
const InsurancePaymentIcon = require('../styles/webroot/images/insurance-payment.svg');


type CommonCountType = {
    count: number,
    name: string,
    status: number,
    substatus: number
}
type DashboardCountType = {
    pending_app: CommonCountType,
    new_app: CommonCountType,
    ins_broker: CommonCountType,
    soft_approval: CommonCountType,
    ins_policy: CommonCountType,
    ins_payment: CommonCountType,
    incentive_payment: CommonCountType,
    lost: CommonCountType,
    inbound_payment: CommonCountType,
    outbound_payment: CommonCountType,
    partner_payment: CommonCountType,
    verification_pending:CommonCountType
}


export default function Dashboard(props: any): ReturnType<React.FC> {
    let [dashboardCount, setDashboardCount] = useState<DashboardCountType>();
    let [loading, setLoading] = useState<boolean>(false)
    const [name, setName] = useState("");
    /* eslint-disable @typescript-eslint/no-unused-vars */
    const [redirect, setRedirect] = useState(false);
    const [role, setRole] = useState("");
    /* eslint-enable @typescript-eslint/no-unused-vars */
    let [searchValue, setSearchValue] = useState<string>()
    const navigate = useNavigate();
    const dispatch: any = useDispatch()
    const { translations } = useLanguage();
    const insurance = useSelector((state: any) => state.insurance)

    useEffect(() => {
        let result = secureStorage.getItem("authUserInfo");

        if (!result) {
            setRedirect(true)
        } else {
            let userInfo = result.user_data;
            setName((userInfo && userInfo.name) || '');
            setRole(userInfo && userInfo.role_title);

        }
        
    }, []);

    const setNewState = () => {
        //     dispatch(userNameSet("Insurance Box"))
    }
    
    const countClickHandler = (status: any, substatus: any, count: any, filterType: any="") => {
        substatus = substatus.toString();

        //NAVAIGATION FOR AGENCY NEW LEADS
        if(filterType === "newAgencyLead"){
            navigate({
                pathname: '/insurance-list',
                search: `?status_id_arr=${status}&sub_status_id_arr=${substatus}&application_type=${APP_AGENCY}`,
            });
        }else{

            if (count !== 0) {
                navigate({
                    pathname: '/insurance-list',
                    search: `?status_id_arr=${status}&sub_status_id_arr=${substatus}${filterType? `&filterType=${filterType}` : '' }`,
                });
            }
        }

    }

    const DashboardCount = () => {
        setLoading(true);
        dispatch(getDashboardCount()).then((res: any) => {
            setLoading(false)
            if (res && res.status === STATUS_SUCCESS) {
                setDashboardCount(res.data);
            }
        }).catch((err: Error) => {
            setLoading(false)
        })
    }

    const searchClickHandler = () => {
        if (searchValue) {
            if (searchValue.length <= 10) {
                navigate({
                    pathname: '/insurance-list',
                    search: `?searchKeyword=${searchValue}`,
                });
            } else {
                toast.error(translations.Dashboard?.['search_error_length_msg'] || translations.commonMsg?.loading);
            }
        } else {
            toast.error(translations.Dashboard?.['search_error_msg'] || translations.commonMsg?.loading);
        }
    }

    useEffect(() => {
        DashboardCount();
        // eslint-disable-next-line
    }, [])

    const onChangeHandler = (value: string) => {
        setSearchValue("");

        if (value.trim()) {
            setSearchValue(value);
        }
    }

    return (
        <React.Fragment>
            <FullPageLoader show={loading} />
            <div className="dashboard-bg">
                <div className="dashboard-outer">
                    <div className="heading">
                        <span className="subheading">{translations.Dashboard?.['Hello'] || translations.commonMsg?.loading} {name}</span>

                        <h1 onClick={setNewState}>{translations.Dashboard?.['Welcome to Insurance Box'] || translations.commonMsg?.loading}</h1>
                        {/* <h1 onClick={setNewState}>{t("COMMON.WELCOME_INSURANCEBOX")}</h1> */}
                    </div>
                    <div className="search-bx">
                        <input name="search" value={searchValue} onChange={(e: any) => onChangeHandler(e.target.value)} type="text" placeholder={translations.Dashboard?.['Search by Insurance Id or Mobile'] || translations.commonMsg?.loading} maxLength={10} />
                        <button className="search-btn" onClick={searchClickHandler}>{translations.Dashboard?.['Search'] || translations.commonMsg?.loading}</button>
                        <i className="ic-search"></i>
                    </div>
                    <div className="dashboard-toggle-tab">
                        <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <div className="dashboard-card">
                                        {
                                            FEATURE_LISTING['DASHBOARD']['CARDS']['pending_application']
                                            && <div className="card color-one" >
                                                <div className="roung-bg">
                                                    <i className="ic-pending-application">
                                                        <i className="path1"></i>
                                                        <i className="path2"></i>
                                                        <i className="path3"></i>
                                                        <i className="path4"></i>
                                                        <i className="path5"></i>
                                                        <i className="path6"></i>
                                                        <i className="path7"></i>
                                                        <i className="path8"></i>
                                                        <i className="path9"></i>
                                                        <i className="path10"></i>
                                                    </i>
                                                </div>
                                                <span className="count-txt" onClick={() => countClickHandler(dashboardCount?.pending_app?.status, dashboardCount?.pending_app?.substatus, dashboardCount?.pending_app?.count, "pending")}>{dashboardCount?.pending_app?.count}</span>
                                                <span className="card-txt">{dashboardCount?.pending_app?.name}</span>
                                            </div>
                                        }
                                        {
                                            FEATURE_LISTING['DASHBOARD']['CARDS']['verification_pending']
                                            &&
                                            <div className="card color-three">
                                                <div className="roung-bg">
                                                    <i className="ic-application"></i>
                                                </div>
                                                <span className="count-txt" onClick={() => countClickHandler(dashboardCount?.verification_pending?.status, dashboardCount?.verification_pending?.substatus, dashboardCount?.verification_pending?.count)}>{dashboardCount?.verification_pending?.count}
                                                </span>
                                                <span className="card-txt">{translations.Dashboard?.['new_app'] || dashboardCount?.verification_pending?.name}
                                                </span>
                                                {/* {!INS_INSURANCE_ID_STAGE && dashboardCount?.new_app?.name && <span className='agency-dashboard-count' style={{ whiteSpace: "nowrap" }} onClick={() => countClickHandler(dashboardCount?.new_app?.status, dashboardCount?.new_app?.substatus, insurance?.agencyLeadCountDashboard, "newAgencyLead")}>{insurance?.agencyLeadCountDashboard} Agency App</span> } */}
                                            </div>
                                        }

                                        {
                                            FEATURE_LISTING['DASHBOARD']['CARDS']['new_application']
                                            &&
                                            <div className="card color-three">
                                                <div className="roung-bg">
                                                    <i className="ic-application"></i>
                                                </div>
                                                <span className="count-txt" onClick={() => countClickHandler(dashboardCount?.new_app?.status, dashboardCount?.new_app?.substatus, dashboardCount?.new_app?.count)}>{dashboardCount?.new_app?.count}
                                                </span>
                                                <span className="card-txt">{translations.Dashboard?.['new_app'] || dashboardCount?.new_app?.name}
                                                </span>
                                                {!INS_INSURANCE_ID_STAGE && dashboardCount?.new_app?.name && <span className='agency-dashboard-count' style={{ whiteSpace: "nowrap" }} onClick={() => countClickHandler(dashboardCount?.new_app?.status, dashboardCount?.new_app?.substatus, insurance?.agencyLeadCountDashboard, "newAgencyLead")}>{insurance?.agencyLeadCountDashboard} Agency App</span> }
                                                {/* {!INS_INSURANCE_ID_STAGE && dashboardCount?.new_app?.name && <span className='agency-dashboard-count' onClick={() => countClickHandler(dashboardCount?.new_app?.status, dashboardCount?.new_app?.substatus, insurance?.agencyLeadCountDashboard, "newAgencyLead")}>{insurance?.agencyLeadCountDashboard} Agency App</span> } */}
                                            </div>
                                        }


                                        {
                                            FEATURE_LISTING['DASHBOARD']['CARDS']['send_to_insurance_broker']
                                            &&
                                            <div className="card color-three" onClick={() => countClickHandler(dashboardCount?.ins_broker?.status, dashboardCount?.ins_broker?.substatus, dashboardCount?.ins_broker?.count)}>
                                                <div className="roung-bg">
                                                    <i className="ic-financier">
                                                        <i className="path1"></i>
                                                        <i className="path2"></i>
                                                        <i className="path3"></i>
                                                        <i className="path4"></i>
                                                        <i className="path5"></i>
                                                        <i className="path6"></i>
                                                        <i className="path7"></i>
                                                        <i className="path8"></i>
                                                        <i className="path9"></i>
                                                        <i className="path10"></i>
                                                    </i>
                                                </div>
                                                <span className="count-txt ">{dashboardCount?.ins_broker?.count}</span>
                                                <span className="card-txt">{translations.Dashboard?.['ins_broker'] || dashboardCount?.ins_broker?.name}</span>
                                            </div>
                                        }

                                        {
                                            FEATURE_LISTING['DASHBOARD']['CARDS']['soft_approval']
                                            &&
                                            <div className="card color-four">
                                                <div className="roung-bg">
                                                    <i className="ic-softapproved">
                                                        <i className="path1"></i>
                                                        <i className="path2"></i>
                                                        <i className="path3"></i>
                                                        <i className="path4"></i>
                                                        <i className="path5"></i>
                                                        <i className="path6"></i>
                                                        <i className="path7"></i>
                                                        <i className="path8"></i>
                                                    </i>
                                                </div>
                                                <span className="count-txt " onClick={() => countClickHandler(dashboardCount?.soft_approval?.status, dashboardCount?.soft_approval?.substatus, dashboardCount?.soft_approval?.count)}>{dashboardCount?.soft_approval?.count}</span>
                                                <span className="card-txt">{dashboardCount?.soft_approval?.name}</span>
                                            </div>
                                        }

                                        {
                                            FEATURE_LISTING['DASHBOARD']['CARDS']['insurance_policy']
                                            &&
                                            <div className="card color-five" onClick={() => countClickHandler(dashboardCount?.ins_policy?.status, dashboardCount?.ins_policy?.substatus, dashboardCount?.ins_policy?.count)}>
                                                <div className="roung-bg">
                                                    <i className="ic-softapproved">
                                                        <i className="path1"></i>
                                                        <i className="path2"></i>
                                                        <i className="path3"></i>
                                                        <i className="path4"></i>
                                                        <i className="path5"></i>
                                                        <i className="path6"></i>
                                                        <i className="path7"></i>
                                                        <i className="path8"></i>
                                                    </i>
                                                </div>
                                                <span className="count-txt ">{dashboardCount?.ins_policy?.count}</span>
                                                <span className="card-txt">{translations.Dashboard?.['ins_policy'] || dashboardCount?.ins_policy?.name}</span>
                                            </div>
                                        }

                                        {
                                            FEATURE_LISTING['DASHBOARD']['CARDS']['insurance_payment']
                                            &&
                                            <div className="card color-two" onClick={() => countClickHandler(dashboardCount?.ins_payment?.status, dashboardCount?.ins_payment?.substatus, dashboardCount?.ins_payment?.count)}>
                                                <div className="roung-bg insurance-payment-icon">
                                                    <img src={InsurancePaymentIcon.default} alt="" />
                                                </div>
                                                <span className="count-txt ">{dashboardCount?.ins_payment?.count}</span>
                                                <span className="card-txt">{dashboardCount?.ins_payment?.name}</span>
                                            </div>

                                        }

                                        {
                                            FEATURE_LISTING['DASHBOARD']['CARDS']['inbound_payment']
                                            &&
                                            <div className="card color-two">
                                                <div className="roung-bg insurance-payment-icon">
                                                    <img src={InsurancePaymentIcon.default} alt="" />
                                                </div>
                                                <span className="count-txt " onClick={() => countClickHandler(dashboardCount?.inbound_payment?.status, dashboardCount?.inbound_payment?.substatus, dashboardCount?.inbound_payment?.count)}>{dashboardCount?.inbound_payment?.count}</span>
                                                <span className="card-txt">{translations.Dashboard?.['inbound_payment'] || dashboardCount?.inbound_payment?.name}</span>
                                            </div>

                                        }

                                        {
                                            FEATURE_LISTING['DASHBOARD']['CARDS']['incentive_payment']
                                            &&
                                            <div className="card color-three" onClick={() => countClickHandler(dashboardCount?.incentive_payment?.status, dashboardCount?.incentive_payment?.substatus, dashboardCount?.incentive_payment?.count)}>
                                                <div className="roung-bg">
                                                    <i className="ic-disbursed">
                                                        <i className="path1"></i>
                                                        <i className="path2"></i>
                                                        <i className="path3"></i>
                                                        <i className="path4"></i>
                                                    </i>
                                                </div>
                                                <span className="count-txt ">{dashboardCount?.incentive_payment?.count}</span>
                                                <span className="card-txt">{dashboardCount?.incentive_payment?.name}</span>
                                            </div>

                                        }

                                        {
                                            FEATURE_LISTING['DASHBOARD']['CARDS']['outbound_payment']
                                            &&
                                            <div className="card color-three">
                                                <div className="roung-bg">
                                                    <i className="ic-disbursed">
                                                        <i className="path1"></i>
                                                        <i className="path2"></i>
                                                        <i className="path3"></i>
                                                        <i className="path4"></i>
                                                    </i>
                                                </div>
                                                <span className="count-txt " onClick={() => countClickHandler(dashboardCount?.outbound_payment?.status, dashboardCount?.outbound_payment?.substatus, dashboardCount?.outbound_payment?.count)}>{dashboardCount?.outbound_payment?.count}</span>
                                                <span className="card-txt">{translations.Dashboard?.['outbound_payment'] || dashboardCount?.outbound_payment?.name}</span>
                                            </div>

                                        }

                                        {
                                            FEATURE_LISTING['DASHBOARD']['CARDS']['partner_payment']
                                            &&
                                            <div className="card color-three" onClick={() => countClickHandler(dashboardCount?.partner_payment?.status, dashboardCount?.partner_payment?.substatus, dashboardCount?.partner_payment?.count)}>
                                                <div className="roung-bg">
                                                    <i className="ic-disbursed">
                                                        <i className="path1"></i>
                                                        <i className="path2"></i>
                                                        <i className="path3"></i>
                                                        <i className="path4"></i>
                                                    </i>
                                                </div>
                                                <span className="count-txt ">{dashboardCount?.partner_payment?.count}</span>
                                                <span className="card-txt">{translations.Dashboard?.['partner_payment'] || dashboardCount?.partner_payment?.name}</span>
                                            </div>

                                        }

                                        {
                                            FEATURE_LISTING['DASHBOARD']['CARDS']['lost']
                                            &&
                                            <div className="card color-four" onClick={() => countClickHandler(dashboardCount?.lost?.status, dashboardCount?.lost?.substatus, dashboardCount?.lost?.count)}>
                                                <div className="roung-bg">
                                                    <i className="ic-lost">
                                                        <i className="path1"></i>
                                                        <i className="path2"></i>
                                                        <i className="path3"></i>
                                                        <i className="path4"></i>
                                                    </i>
                                                </div>
                                                <span className="count-txt ">{dashboardCount?.lost?.count}</span>
                                                <span className="card-txt">{translations.Dashboard?.['lost'] || dashboardCount?.lost?.name}</span>
                                            </div>
                                        }


                                    </div>
                                </Tab.Pane>

                            </Tab.Content>
                        </Tab.Container>
                    </div>
                </div>
            </div>
        </React.Fragment >
    )
}

